export enum CUSTOM_USER_EVENT {
  REGISTRO_OK = "registro_ok",
  REGISTRO_FAIL = "registro_ko",
  LOGIN_OK = "login_ok",
  LOGIN_FAIL = "login_ko",
  NEWSLETTER = "newsletter"
}

export enum USER_FORM_STATUS {
  OK = "ok",
  FAIL = "ko",
}

export enum USER_FORM_TYPE {
  REGISTRO = "registro",
  NEWSLETTER = "newsletter",
}

export enum USER_REGISTER_TYPE {
  EMPRESA = 'empresa',
  PARTICULAR = "particular",
  NONE = ''
}

export class LoadCustomUserPayloadEventModel {
  payload: any
}
